export default "__VITE_ASSET__BJ1KEEMC__"